import { generateAuthorPersonSchema } from "./authorSchemaGenerator";

interface BlogPostSchemaProps {
  title: string;
  excerpt?: string;
  content: string;
  slug: string;
  publishedAt: string;
  updatedAt: string;
  author?: {
    full_name: string | null;
    email?: string;
    bio?: string | null;
    job_title?: string | null;
    expertise_areas?: string[] | null;
    linkedin_url?: string | null;
    twitter_url?: string | null;
    website_url?: string | null;
    credentials?: string | null;
    avatar_url?: string | null;
    author_slug?: string | null;
  };
  imageUrl?: string;
  category?: string;
  tags?: string[];
}

export const generateBlogPostSchema = ({
  title,
  excerpt,
  content,
  slug,
  publishedAt,
  updatedAt,
  author,
  imageUrl,
  category,
  tags,
}: BlogPostSchemaProps) => {
  const baseUrl = window.location.origin;
  const postUrl = `${baseUrl}/blog/${slug}`;
  
  // Calculate word count
  const wordCount = content.split(/\s+/).filter(word => word.length > 0).length;
  
  // Generate rich author schema with E-E-A-T signals
  const authorSchema = author 
    ? generateAuthorPersonSchema({
        full_name: author.full_name || "iQ Team",
        email: author.email,
        bio: author.bio || undefined,
        job_title: author.job_title || undefined,
        expertise_areas: author.expertise_areas || undefined,
        linkedin_url: author.linkedin_url || undefined,
        twitter_url: author.twitter_url || undefined,
        website_url: author.website_url || undefined,
        credentials: author.credentials || undefined,
        avatar_url: author.avatar_url || undefined,
        author_slug: author.author_slug || undefined,
      })
    : {
        "@type": "Person",
        name: "iQ Team",
        worksFor: {
          "@type": "Organization",
          name: "iQ Texting",
        },
      };
  
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: title,
    description: excerpt || content.substring(0, 160),
    image: imageUrl || `${baseUrl}/og-image.png`,
    datePublished: publishedAt,
    dateModified: updatedAt,
    author: authorSchema,
    publisher: {
      "@type": "Organization",
      name: "iQ Texting",
      logo: {
        "@type": "ImageObject",
        url: `${baseUrl}/logo.png`,
      },
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": postUrl,
    },
    url: postUrl,
    wordCount: wordCount,
    ...(category && { articleSection: category }),
    ...(tags && tags.length > 0 && { keywords: tags }),
    ...(imageUrl && { thumbnailUrl: imageUrl }),
    articleBody: content.substring(0, 5000),
  };
};
